import { GenericAbortSignal } from 'axios';

import Credential, { CredentialOptions } from 'models/flexible/Credential';
import { Paginated } from 'models/flexible/Paginated';
import http from 'services/http';

export const adminCredentialsQueryKeys = {
  index: () => ['adminCredentials'] as const,
};

export async function adminIndexCredentials(params?: Record<string, any>, signal?: GenericAbortSignal) {
  return http.get<Paginated<CredentialOptions>>('credentials', { params, signal }).then((res) => ({
    ...res.data,
    data: (res.data.data ?? []).map((x) => new Credential(x)),
  }));
}
